
<template>
	<v-container fluid grid-list-md>
		<h1 class="hidden-sm-and-down">Tracker</h1>
		<v-flex xs12 md12 elevation-0>
			<v-tabs v-model="active" centered fixed-tabs color="transparent">
				<v-tab :key="'Actief'" :href="'#Actief'" ripple>Units</v-tab>
				<v-tab :key="'Historie'" :href="'#Historie'" ripple>Historie</v-tab>
				<v-tabs-slider color="blue darken-2"></v-tabs-slider>
				<v-tabs-items>
					<v-tab-item :key="'Actief'" :value="'Actief'">
						<active-test-drives
							:active="active === 'Actief'"
						></active-test-drives>
					</v-tab-item>
					<v-tab-item :key="'Historie'" :value="'Historie'">
						<test-drives-history-table :ts="ts"></test-drives-history-table>
					</v-tab-item>
				</v-tabs-items>
			</v-tabs>
		</v-flex>
	</v-container>
</template>
<script>
import * as utils from '@/utils/utils';
import ActiveTestDrives from '@/components/TestDrives/ActiveTestDrives';
import TestDrivesHistoryTable from '@/components/TestDrives/TestDrivesHistoryTable';
import UnitTrackCard from '@/components/TestDrives/UnitTrackCard';
import { StatusIndicator } from 'vue-status-indicator';
import moment from 'moment';

export default {
	name: 'TestDrive',
	components: {
		UnitTrackCard,
		StatusIndicator,
		ActiveTestDrives,
		TestDrivesHistoryTable
	},
	data() {
		return {
			active: 'Actief',
			dialog: false,
			rowsPerPageItems: [4, 8, 12],
			pagination: {
				rowsPerPage: 4
			},
			items: [
				{
					s: '',
					pos: {},
					location: 1
				}
			],
			description: '',
			utils: utils,
			ts: 0
		};
	},
	watch: {
		active(newVal) {
			if (newVal === 'Historie') {
				this.ts = this.utils.getTimestamp();
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/TestDrives/TestDrive.vue